const ASSISTED_SERVICE_CHANNEL = 'assisted-service-session';

// Generate a unique ID for this tab instance
const tabId = Math.random().toString(36).substring(2, 15);

export interface AssistedServiceMessage {
  type: 'session-ended';
  tabId: string;
}

/**
 * Send a session-ended message to other tabs.
 * Creates a temporary BroadcastChannel, sends the message, and closes it.
 */
export const sendSessionEndedMessage = (): void => {
  const channel = new BroadcastChannel(ASSISTED_SERVICE_CHANNEL);
  const message: AssistedServiceMessage = {
    type: 'session-ended',
    tabId,
  };
  channel.postMessage(message);
  channel.close();
};

/**
 * Check if a message was sent from the current tab.
 */
export const isMessageFromCurrentTab = (message: AssistedServiceMessage): boolean => {
  return message.tabId === tabId;
};

/**
 * Create a BroadcastChannel for listening to assisted service messages.
 */
export const createAssistedServiceChannel = (): BroadcastChannel => {
  return new BroadcastChannel(ASSISTED_SERVICE_CHANNEL);
};
